import "./App.css";

import Parse from "parse";

import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import { DashBoard } from "./Components/Pages/DashBoard";
import Chat from "./Components/Pages/Chat";
import Coaching from "./Components/Pages/Coaching";
import { Events } from "./Components/Pages/Events";
import { Offers } from "./Components/Pages/Offers";
import Profil from "./Components/Pages/Profil";
import Header from "./Components/Header/Header";
import { ChakraProvider } from "@chakra-ui/react";
import { ShowOffer } from "./Components/ShowOffer.jsx";
import AfficherOffres from "./Components/AfficherOffres";
import DetailUser from "./Components/DetailUser";
import EditerOffres from "./Components/EditerOffres";
import EditerEvents from "./Components/EditerEvents";
import AfficherEvents from "./Components/AfficherEvents";
import ConnexionPage from "./Components/Pages/ConnexionPage";
import MdpOublie from "./Components/MdpOublie";
import HandleLinkedInOauth from "./Components/HandleLinkedInOauth";
import { useState, useEffect } from "react";

// Your Parse initialization configuration goes here
const PARSE_APPLICATION_ID = "lHGg20jAA0bD1aRDKri7Fs03mOWfcMPvvYT2BNYv";
const PARSE_HOST_URL = "https://parseapi.back4app.com/";
const PARSE_JAVASCRIPT_KEY = "HklKEtjpQQm14wGV7hyfEh8HHrN1mBpL9d7ZD1pq";

// test

// const PARSE_APPLICATION_ID = "B9Avr3A5CPOhdFcoRp2CJJ4qBohC5n3SitfoZijc";
// const PARSE_HOST_URL = "https://parseapi.back4app.com/";
// const PARSE_JAVASCRIPT_KEY = "baluHiqKZDw0dfjWPIDofcP96yMOmpBD7demrf18";

Parse.initialize(PARSE_APPLICATION_ID, PARSE_JAVASCRIPT_KEY);
Parse.serverURL = PARSE_HOST_URL;

function App() {
  document.body.style = "background: #FFFFFF;";

  const [showAvatar, setShowAvatar] = useState(true);

  useEffect(() => {
    if (window.location.href === "http://localhost:3000/") {
      setShowAvatar(false);
    }
  }, []);

  const showImageHeader = (state) => {
    setShowAvatar(state);
  };

  return (
    <ChakraProvider>
      <Router>
        {showAvatar ? <Header showImageHeader={showImageHeader} /> : ""}
        <Routes>
          <Route
            path="/linkedin"
            element={<HandleLinkedInOauth showImageHeader={showImageHeader} />}
          />
          <Route
            path="/"
            element={<ConnexionPage showImageHeader={showImageHeader} />}
          />
          <Route path="/MdpOublie" element={<MdpOublie />} />
          <Route path="/DashBoard" element={<DashBoard />} />
          <Route path="/Chat" element={<Chat />} />
          <Route path="/Coaching" element={<Coaching />} />
          <Route path="/Events" element={<Events />} />
          <Route path="/Offers" element={<Offers />} />
          <Route path="/Profil" element={<Profil />} />
          <Route path="/ShowOffer" element={<ShowOffer />} />
          <Route path="/AfficherOffres/:id" element={<AfficherOffres />} />
          <Route path="/DetailUser/:id" element={<DetailUser />} />
          <Route path="/EditerOffres/:id" element={<EditerOffres />} />
          <Route path="/AfficherEvents/:id" element={<AfficherEvents />} />
          <Route path="/EditerEvents/:id" element={<EditerEvents />} />
        </Routes>
      </Router>
    </ChakraProvider>
  );
}

export default App;

/*
modif data event dashboard
description data event dashboard
afficher event front + list users
afficher offre front + list users
add taux de remplissage a afficher event
ajout filtre nb de matching
*/
